import {
  Autocomplete,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
} from "@mui/material";
import { collection, doc, setDoc } from "firebase/firestore";
import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { db } from "../../../../api/firebase";
import { nbfCustomerTrayAccount, nbfTrayStore, trayUpdate } from "../../../../api/restApi";
import { customersData } from "../../../../store/reducer/customersSlice";
import { useAppDispatch, useAppSelector } from "../../../../utils/hooks";
import TrayTable from "../../Tables/TrayTable";
import { UpdateTrayModal } from "./UpdateTrayModal";
import { trayData, setTray } from "../../../../store/reducer/traysSlice";
const Tray = () => {
  const [createModalOpen, setCreateModalOpen] = useState(false);
  const [paymentModalOpen, setPaymentModalOpen] = useState(false);
  const [customerTrayAccount,setCustomerTrayAccount]=useState([]);

  const { tray } = useAppSelector(trayData);
  const CollectionName = "tray";
  const dispatch = useAppDispatch();

  const name = useSelector((state) => state.currentUser.name);

  useEffect(() => {
    const fetchData = async () => {
      const trayAccount = await nbfCustomerTrayAccount();
      setCustomerTrayAccount(trayAccount);
    };

    fetchData();
  }, [tray]);

  const nbfTrayInfo = async () => {
    let trayAccount = await nbfCustomerTrayAccount();
    dispatch(setTray(trayAccount));
    console.log(trayAccount);
  };
  // useEffect(() => {
  //   nbfTrayInfo();
  // }, []);

  const handleCreateNewRow = async (values, id) => {
    try {
      if (!values || Object.keys(values).length === 0) {
        alert("Please enter valid data");
        return;
      }
      const check = customerTrayAccount.find(el => values.selectedCustomer.id === parseInt(el.id));
      if(check){
        return alert("This customer already have an account");
      }
      values = {
        ...values,
        history: [
          {
            action: "created new account",
            timestamp: new Date(),
            user: name,
          },
        ],
      };

      const newDocRef = doc(
        collection(db, CollectionName),
        values.selectedCustomer.id.toString()
      );
      await setDoc(newDocRef, values);

      console.log(values);
      // ----------------------------------------------------------------------------
      // Need to create opening balance here for the customer
      // create new function inside HelperClass.js and call it here instead of CreateNewCustomer.
      // let createLevel3Code =await CreateNewCustomer({...values.selectedCustomer},level_3,values.trayAPending)
      // ----------------------------------------------------------------------------
      toast.success("Successfully add new item !", {
        position: toast.POSITION.BOTTOM_CENTER,
      });
      nbfTrayInfo();
    } catch (error) {
      console.log(error);
      toast.error("Failed to add new item !", {
        position: toast.POSITION.BOTTOM_CENTER,
      });
    }
  };

  const handleUpdateTray = async (values) => {
    console.log(values.selectedCustomer.id);
    console.log(customerTrayAccount)
    console.log(values)
    // if (parseFloat(values.trayAReturn + "") || parseFloat(values.trayBReturn + "") < 0) {
    //   alert("Please enter valid data");
    //   return;
    // }

    const check = customerTrayAccount.find(el => values.selectedCustomer.id === parseInt(el.id));
    if(check===undefined){
      return alert("Please Create Account First");
    }

    try {
      const response = await trayUpdate({
        id: values.selectedCustomer.id,
        trayAReturn:values.trayAReturn,
        trayBReturn:values.trayBReturn,
        trayADispatch:0,
        trayBDispatch:0,
      });

      console.log(response)

      if (response.status === 200) {
        toast.success("Successfully add new item !", {
          position: toast.POSITION.BOTTOM_CENTER,
        });
        nbfTrayInfo();
      } else {
        toast.error("Failed to update tray !", {
          position: toast.POSITION.BOTTOM_CENTER,
        });
      }
    } catch (error) {
      console.log(error);
      toast.error("Failed to update payment !", {
        position: toast.POSITION.BOTTOM_CENTER,
      });
    }
  };

  const columns = useMemo(() => [
    {
      accessorKey: "id",
      header: "ID",
      enableColumnOrdering: false,
      enableEditing: false, //disable editing on this column
      enableSorting: false,
      Cell: ({ row }) => row.original.selectedCustomer.id,
      size: 80,
    },
    {
      accessorKey: "name_english",
      header: "Name_English",
      size: 140,
      Cell: ({ row }) => row.original.selectedCustomer.name_english,
    },
    {
      accessorKey: "name_urdu",
      header: "Name_Urdu",
      size: 140,
      Cell: ({ row }) => row.original.selectedCustomer.name_urdu,
    },
    {
      accessorKey: "trayAPending",
      header: "trayAPending",
      size: 140,
    },
    {
      accessorKey: "trayBPending",
      header: "trayBPending",
      size: 140,
    },
  ]);

  return (
    <>
      <Stack spacing={4} marginX={4} mt={1}>
        <TrayTable
          setCreateModalOpen={setCreateModalOpen}
          setPaymentModalOpen={setPaymentModalOpen}
          tableData={tray}
          columns={columns}
          csvFileName="payment"
        />
      </Stack>
      <NewAccountModal
        columns={columns}
        open={createModalOpen}
        onClose={() => setCreateModalOpen(false)}
        onSubmit={handleCreateNewRow}
      />
      <UpdateTrayModal
        customersData={customersData}
        columns={columns}
        open={paymentModalOpen}
        onClose={() => setPaymentModalOpen(false)}
        onSubmit={handleUpdateTray}
      />
    </>
  );
};


export const NewAccountModal = ({ open, onClose, onSubmit }) => {
  const { customers } = useAppSelector(customersData);

  const initialValues = {
    selectedCustomer: "",
    trayAPending: 0,
    trayBPending: 0,
  };
  const [values, setValues] = useState(initialValues);
  const [customersOption, setCustomersOption] = useState([]);

  const handleSubmit = async () => {
    // Submit the form
    onSubmit(values);
    setCustomersOption(initialValues)
    onClose();
  };

  useEffect(() => {
    setCustomersOption([
      ...customers.map((data) => {
        data = {
          ...data,
          label: data.name_english + " " + data.name_urdu,
        };
        return data;
      }),
    ]);
  }, []);

  const handleSelectCustomer = async (event, newValue) => {
    setValues({ ...values, selectedCustomer: newValue });
  };

  console.log(values);

  return (
    <>
      <Dialog open={open}>
        <DialogTitle textAlign="center">Create Account</DialogTitle>
        <DialogContent>
          <form onSubmit={(e) => e.preventDefault()}>
            <Stack
              sx={{
                width: "100%",
                minWidth: { xs: "300px", sm: "360px", md: "400px" },
                gap: "1.5rem",
              }}
            >
              <Box>
                <label>Selected Customer</label>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={customersOption || []}
                  sx={{
                    minWidth: 200,
                    display: "flex",
                  }}
                  value={values.selectedCustomer||''||null}
                  onChange={handleSelectCustomer}
                  renderInput={(params) => (
                    <TextField {...params} label="Customer" />
                  )}
                />
              </Box>
              <Box>
                <label>Starting Tray-A</label>
                <TextField
                  sx={{ minWidth: "100%", marginTop: 2 }}
                  label="Enter TrayA"
                  type="number"
                  value={values.trayAPending}
                  onChange={(e) =>
                    setValues({ ...values, trayAPending: e.target.value })
                  }
                />
              </Box>
              <Box>
                <label>Starting Tray-B</label>
                <TextField
                  sx={{ minWidth: "100%", marginTop: 2 }}
                  label="Enter TrayB"
                  type="number"
                  value={values.trayBPending}
                  onChange={(e) =>
                    setValues({ ...values, trayBPending: e.target.value })
                  }
                />
              </Box>
            </Stack>
          </form>
        </DialogContent>
        <DialogActions sx={{ p: "1.25rem" }}>
          <Button onClick={onClose}>Cancel</Button>
          <Button color="secondary" onClick={handleSubmit} variant="contained">
            Create
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default Tray;
